export function getDeviceType() {
  const ua = navigator.userAgent;
  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
    return "tablet";
  } else if (
    /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)
  ) {
    return "mobile";
  }
  return "desktop";
};

export function isAppleDevice() {
  if (navigator.userAgent.match(/iPhone|iPad|iPod/i)) 
    return true;
  return false;
}

export function getOperatingSystem() {
  let userAgent = window.navigator.userAgent;
  let platform = (navigator as any).userAgentData ? (navigator as any).userAgentData.platform : 'unknown';
  let macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];
  let windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];
  let iosPlatforms = ['iPhone', 'iPad', 'iPod'];
  let os = null;

  if (macosPlatforms.indexOf(platform) !== -1) {
    os = 'Mac';
  } else if (iosPlatforms.indexOf(platform) !== -1) {
    os = 'iOS';
  } else if (windowsPlatforms.indexOf(platform) !== -1) {
    os = 'Windows';
  } else if (/Android/.test(userAgent)) {
    os = 'Android';
  } else if (!os && /Linux/.test(platform)) {
    os = 'Linux';
  }

  return os;
}

/**
 * check the input if is a valid number
 * @param value 
 * @returns 
 */
export function checkNumber(value: string) {
  const regex = /^[0-9]*$/; // 0-9 number

  if (regex.test(value)) {
    return true;
  } else {
    return false;
  }
};

/**
 * Format time to twitter style ones
 * @param time timestamp in seconds
 * @param ago the 'ago' suffix 
 * @returns the time formatted
 */
export function formatTimestamp(time: number, ago?: boolean) {

  const m = new Map([[1, 'Jan'], [2, 'Feb'], [3, 'Mar'], [4, 'Apr'], [5, 'May'], [6, 'Jun'], 
    [7, 'Jul'], [8, 'Aug'], [9, 'Sep'], [10, 'Oct'], [11, 'Nov'], [12, 'Dec']]);

  let now  = secondsOfNow();
  let diff = now - time;

  const days    = Math.floor(diff / (60 * 60 * 24));
  const hours   = Math.floor((diff % (60 * 60 * 24)) / (60 * 60));
  const minutes = Math.floor((diff % (60 * 60)) / 60);
  const seconds = Math.floor(diff % 60);

  if (days > 0) {
    const date = new Date(time * 1000);
    
    if (days > 365) {
      return date.toLocaleString();
    } else {
      const month = date.getMonth() + 1;
      const day   = date.getDate();
      return m.get(month) + ' ' + day;
    }
  }

  if (hours > 0) {
    let t = hours + 'h';
    if (ago) t += ' ago';
    return t;
  }

  if (minutes > 0) {
    let t = minutes + 'm';
    if (ago) t += ' ago';
    return t;
  }

  if (seconds > 0) {
    let t = seconds + 's';
    if (ago) t += ' ago';
    return t;
  }

  return 'just now';
};

/**
 * Gets the time value of now in milliseconds.
 * @returns the time value in milliseconds
 */
export function msOfNow() {
  return new Date().getTime();
}

/**
 * Gets the time value of now in seconds.
 * @returns the time value in seconds
 */
export function secondsOfNow() {
  return Math.floor(new Date().getTime() / 1000);
}

/**
 * Gets the unique id.
 * @returns the unique id
 */
export function uniqueId() {
  return Math.floor(Math.random() * 1000000);
}

/**
 * Generate a random number between min and max, including both min and max.
 * @param min 
 * @param max 
 * @returns the integer
 */
export function randomInteger(min: number, max: number) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function getMenuIcon(name:string):string {
  return '/icon/' + name + '.png';
}

/**
 * Convert the url in the str to link
 * @param str
 * @returns 
 */
export function urlToLink(str: string):any {
  const re = /(f|ht){1}(tp|tps):\/\/([\w-]+\S)+[\w-]+([\w-?%#&=]*)?(\/[\w- ./?%#&=]*)?/g;
  
  str = str.replace(re, function (url) {
    return `<a href=${url} target="_blank" style="color: white">${url}</a>`;
  });

  return {__html: str};
}


function replaceUrls(str: string): string {
  // console.warn('replaceUrls');
  // console.log(str);

  let urlRegex = /(f|ht){1}(tp|tps):\/\/([\w-]+\S)+[\w-]+([\w-?%#&=@.]*)?(\/[\w- ./?%#&=]*)?/g;

  let match;
  let matches = [];
  while ((match = urlRegex.exec(str)) !== null) {
    matches.push(match);
  }

  // console.log(matches);

  let si = 0;
  for(let i = 0; i < matches.length; i++) {
    // console.warn('MATCH', i);

    let match = matches[i];
    let url = match[0];
    let pos = str.indexOf(url, si);

    // console.log('url', url);
    // console.log('pos', pos);

    if(pos == -1) 
      continue;

    let prefix = str.substring(0, pos);
    let suffix = str.substring(pos + url.length)
    // console.log('prefix', prefix);
    // console.log('suffix', suffix);

    let anchor = `<a href="${url}" target="_blank">${url}</a>`;
    // console.log('anchor', anchor);

    str = prefix + anchor + suffix;
    // console.log(str);
    
    si = pos + anchor.length;
    // console.log('si', si);
  }

  return str;
}

export function convertUrls(str: string): string {
  // console.warn('convertUrls');
  // console.log(str);

  let urlRegex = /(f|ht){1}(tp|tps):\/\/([\w-]+\S)+[\w-]+([\w-?%#&=@.]*)?(\/[\w- ./?%#&=]*)?/g;
  if(!str.match(urlRegex)) {
    // console.log('No URLs found!');
    return str;
  }

  let parser = new DOMParser();
  let doc = parser.parseFromString(str, "text/html");
  // console.log(doc);

  let paragraphs = doc.getElementsByTagName('p');
  // console.log(paragraphs);

  for(let i = 0; i < paragraphs.length; i++) {
    // console.warn('paragraph', i);
    // console.log(paragraphs[i].outerHTML);
    if(paragraphs[i].children.length > 0) {
      // console.log('skipping, has children');
      continue;
    }
    paragraphs[i].innerHTML = replaceUrls(paragraphs[i].innerHTML);
  }

  let test = doc.body.innerHTML;

  // console.warn('FINAL');

  // if(test == str)
  //   console.log('no change');
  // else
  //   console.log(test);
  
  return test;
}

export function isValidUrl(url: string) {
  var pattern = /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w.-]*)*\/?$/;
  return pattern.test(url);
}

export function numberWithCommas(x: number): string {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

/**
 * Convert the substr start with @ to user slug
 * @param str
 * @returns 
 */
export function convertSlug(str: string):any {
  const pattern = /@\w+(-\w+)*/g;
  str = str.replace(pattern, function (slug) {
    return `<slug href='/profile/${slug.substring(1)}' id="${slug}"></slug>`;
  });

  return str;
}

/**
 * Convert the substr which start with # to hash tag
 * @param str
 * @returns 
 */
export function convertHashTag(str: string):any {
  const pattern = /#\w+(-\w+)*/g;
  str = str.replace(pattern, function (hashtag) {
    return `<hashtag href='/activity/hashtag/${hashtag.substring(1)}' id="${hashtag}"></hashtag>`;
  });

  return str;
}

/**
 * get amount of media file from the Quill editor content
 * @param quillRef 
 * @returns 
 */
export function changeBrowserTab(title: string, icon: string) {
  const favicon  = document.querySelector("link[rel*='icon']") as any;
  favicon.href   = icon;
  document.title = title;
}

export function isPlural(s:string) {
  return (s.substring(s.length-1) == 's');
}

export function isLocalHost() {
  return window.location.hostname.indexOf('localhost') != -1;
}

export function getSiteSubDomain() {
  let parts = window.location.hostname.split('.');

  if(parts[0] == 'localhost')
    return 'www';

  if(parts[0] == '192')
    return 'www';

  if(parts[1] == 'localhost')
    return parts[0];

  if(parts[0] == 'www')
    return 'www';

  if(parts[1] == 'oneclick')
    return parts[0];

  return null;
}

export function getFirstLineFromHtml(content:string) {
  let stripped = content;
  let matches = stripped.match(/<\/?("[^"]*"|'[^']*'|[^>])*(>|$)/g);
  if(matches) 
    for(let j = 0; j < matches.length; j++)
      stripped = stripped.replace(matches[j], '');

  let parts = stripped.split(' ');
  let words = parts.length;
  parts.splice(20);
  return parts.join(' ') + ((words > 20) ? '...' : '');
}

export function getUrlsFromContent(content:string) {
  let doc = new DOMParser().parseFromString(content, 'text/html');

  function findTextNodes(node:any, textNodes:any[]) {
    if (node.nodeType === Node.TEXT_NODE) {
      textNodes.push(node);
    } else {
      node.childNodes.forEach(child => findTextNodes(child, textNodes));
    }
  }

  let textNodes = [];
  findTextNodes(doc.body, textNodes);

  const urlRegex = /https?:\/\/[^\s<]+/gi;

  let urls = [];
  for(let i = 0; i < textNodes.length; i++) 
    if(textNodes[i].textContent.match(urlRegex)) 
      urls.push(textNodes[i].textContent);

  return urls;
}


export function isVideoUrl(url:string) {
  let match = url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtube\.com\/watch.*v=([a-zA-Z0-9_-]+)/) ||
      url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtu\.be\/([a-zA-Z0-9_-]+)/) ||
      url.match(/^.*(youtu.be\/|v\/|e\/|u\/\w+\/|embed\/|v=)([^#\&\?]*).*/);
  if (match && match[2].length === 11) {
      return true;
  }
  if (match = url.match(/^(?:(https?):\/\/)?(?:www\.)?vimeo\.com\/(\d+)/)) { // eslint-disable-line no-cond-assign
      return true;
  }
  if (url.indexOf('www.dropbox.com') != -1) {
    return true
  }
  return false;

}

export function getPublicVideoUrl(url:string) {
  let match = url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtube\.com\/watch.*v=([a-zA-Z0-9_-]+)/) ||
      url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtu\.be\/([a-zA-Z0-9_-]+)/) ||
      url.match(/^.*(youtu.be\/|v\/|e\/|u\/\w+\/|embed\/|v=)([^#\&\?]*).*/);
  if (match && match[2].length === 11) {
      return ('https') + '://www.youtube.com/embed/' + match[2] + '?showinfo=0';
  }
  if (match = url.match(/^(?:(https?):\/\/)?(?:www\.)?vimeo\.com\/(\d+)/)) { // eslint-disable-line no-cond-assign
      return (match[1] || 'https') + '://player.vimeo.com/video/' + match[2] + '/';
  }
  if (url.indexOf('www.dropbox.com') != -1) {
    return url.replace('www.dropbox.com', 'dl.dropboxusercontent.com')
  }
  return url;
}



